import { render, staticRenderFns } from "./HistoryLogins.vue?vue&type=template&id=9803a9a4"
import script from "./HistoryLogins.vue?vue&type=script&lang=js"
export * from "./HistoryLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports